<div class="icon" [ngClass]="type">
	<ng-content></ng-content>
</div>
